module.exports = __webpack_public_path__ + "img/Serbia.55d796a6.svg";